import { useRef } from "react";
import { usePubContext } from "../../hooks/pub-context";
import {
  PremiumPubTournamentNoData,
  PremiumPubTournamentsHeader,
  PremiumPubTournamentsWrapper,
} from "./style";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper";
import PremiumPubTournamentItem from "./components/tournament-item";
import PremiumPubTournamentsSkeleton from "./skeleton";

const PremiumPubTournaments = () => {
  const { tournamentList, loading } = usePubContext();
  const swiperRef = useRef<SwiperCore>();

  if (loading) return <PremiumPubTournamentsSkeleton />;

  return (
    <PremiumPubTournamentsWrapper>
      <PremiumPubTournamentsHeader>
        <div className="title">진행중인 게임</div>
        <div className="state">게임 {tournamentList.length} 진행중</div>
      </PremiumPubTournamentsHeader>
      <Swiper
        className="swiper"
        onSwiper={(swiper: any) => (swiperRef.current = swiper)}
        slidesPerView={1.1}
        centeredSlides={false}
        spaceBetween={12}
      >
        {tournamentList.length === 0 ? (
          <PremiumPubTournamentNoData>
            진행중인
            <br />
            토너먼트 정보가 없습니다.
          </PremiumPubTournamentNoData>
        ) : (
          tournamentList.map((item, index) => (
            <SwiperSlide key={index}>
              <PremiumPubTournamentItem item={item} />
            </SwiperSlide>
          ))
        )}
      </Swiper>
    </PremiumPubTournamentsWrapper>
  );
};
export default PremiumPubTournaments;
